import React, { useRef } from 'react'
import styles from './MobileSlider.module.css'
import { Link, useHistory } from "react-router-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import sliderPersonImg from '../../../assets/image/dashboard-images/slider person.png'

const MobileSlider = () => {
    const history = useHistory()

    const slider = useRef(null)

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className={styles.testimonial_slider_wrapper}>
            <style>
                {`
                    .slick-slider .slick-list {
                        padding: 10px 0!important;
                    }

                    .slick-dots li.slick-active button:before {
                        color: rgba(22, 166, 106, 1) !important;
                    }

                    .slick-dots li button:before {
                        color: rgba(22, 166, 106, 1) !important;
                    }
                `}
            </style>

            {/* <button onClick={() => slider.current.slickPrev()} className={styles.slider_ctrl_btn}><FaChevronLeft /></button> */}

            <div className={styles.slider_container}>
                <Slider ref={slider} {...settings}>
                    <div className={styles.testimonial_slider_card}>
                        <section className={styles.main_container}>
                            <div className={styles.bg_img_container}>
                                <div className={styles.main_img_container}>
                                    <img src={sliderPersonImg} alt="" />
                                </div>

                                <div className={styles.banner_text_wrapper}>
                                    <div className={styles.banner_heading}>
                                        <h1>Where the world does markets.</h1>
                                    </div>
                                    <div className={styles.banner_text_content}>
                                        <p>Streamline your business growth with ease. </p>
                                        <button onClick={() => history.push('/signup')}>Join Us</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className={styles.testimonial_slider_card}>
                        <div className={styles.slider_card_body}>
                            {/* <img src={sliderIcon} alt="" /> */}
                            <p>With ThickWallet’s insights, I feel more confident making trades. It’s a game-changer for any investor.</p>
                        </div>
                        <div className={styles.slider_card_footer}>
                            <h6>STEPHEN G.</h6>
                        </div>
                    </div>
                    <div className={styles.testimonial_slider_card}>
                        <div className={styles.slider_card_body}>
                            {/* <img src={sliderIcon} alt="" /> */}
                            <p>ThickWallet’s trend analysis saves me manual effort and helped me spot opportunities faster.</p>
                        </div>
                        <div className={styles.slider_card_footer}>
                            <h6>PRIYA H.</h6>
                        </div>
                    </div>
                </Slider>
            </div>

            {/* <button onClick={() => slider.current.slickNext()} className={styles.slider_ctrl_btn}><FaChevronRight /></button> */}
        </div>
    )
}

export default MobileSlider